<template>
  <div class="container">
    <script
      type="module"
      src="https://cdn.zapier.com/packages/partner-sdk/v0/zapier-elements/zapier-elements.esm.js"
    ></script>
    <link
      rel="stylesheet"
      href="https://cdn.zapier.com/packages/partner-sdk/v0/zapier-elements/zapier-elements.css"
    />
    <div class="row">
      <div class="col-12">
        <TopNav class="mt-4" />
        <img class="mt-3" :srcset="`${logo} 3x`" />
        <p
          class="mt-4 mb-4"
          v-html="
            sanitize($t('SETTINGS.TEXT.ZAPIER_DESCRPTION', { applicationName }))
          "
        ></p>
      </div>
      <div class="col-12">
        <span class="border rounded p-2">{{ teacher.apikey }}</span>
        <button
          type="button"
          class="btn p-0 ml-3"
          v-clipboard:copy="teacher.apikey"
          v-clipboard:success="apikeyCopySuccess"
          v-clipboard:error="apikeyCopyError"
        >
          <i class="far fa-link"></i>
        </button>
      </div>
      <div class="col-12 mt-4">
        <zapier-full-experience
          :clientId.prop="'hE2iwlD0r0JdUEF8MDgBlU2iV0cu8QImm9BsNB6z'"
          :theme.prop="'light'"
          :introCopyDisplay.prop="'show'"
          :appSearchBarDisplay.prop="'show'"
          :appLimit.prop="10"
          :zapLimit.prop="10"
          :zapStyle.prop="'row'"
          :zapCallToActionDisplay.prop="'show'"
          :zapCreateFromScratchDisplay.prop="'show'"
        ></zapier-full-experience>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';

import { getConfig } from '@/web/utils/configuration';
import TopNav from '@/web/components/navigation/TopNav.vue';
import { sanitize } from '@/core/utils/utils';

export default Vue.extend({
  name: 'ZapierIntegration',
  components: {
    TopNav,
  },
  computed: {
    ...mapGetters({
      teacher: 'user/teacher',
    }),
    config() {
      return getConfig();
    },
    applicationName() {
      return this.config.applicationName;
    },
  },
  data() {
    return {
      logo: '/assets/images/integrations/zapier@3x.png',
    };
  },
  methods: {
    sanitize,
    apikeyCopySuccess() {
      this.$notify({
        group: 'app',
        type: 'success',
        title: this.$t('NOTIFICATIONS.TITLE.SUCCESS'),
        text: this.$t('NOTIFICATIONS.TEXT.API_KEY_COPIED_TO_CLIPBOARD'),
      });
    },
    apikeyCopyError() {
      this.$notify({
        group: 'app',
        type: 'error',
        title: this.$t('NOTIFICATIONS.TITLE.ERROR'),
        text: this.$t('NOTIFICATIONS.TEXT.API_KEY_COPY_ERROR'),
        duration: -1, // stay ON
      });
    },
    loadZapierScripts() {},
  },
  mounted() {
    this.loadZapierScripts();
  },
});
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';
</style>
